import type { Shortcut } from '@neo/shared/components/shortcut-key'
import { getShortcutKeyString } from '@neo/shared/components/shortcut-key'
import type { KeyboardShortCutItem } from '@shared/hooks/use-keyboard-shortcuts'
import type { CommandItem } from 'cmdk-engine'

export interface NavigateProps {
  navigate: (path: string, options?: { state?: Record<string, unknown> }) => void
}

/**
 * A cmdk-engine CommandItem plus the REAL keybinding that drives useKeyboardShortcuts.
 * cmdk-engine's own `CommandItem.shortcut` is display-only text — never used for binding.
 */
export interface AppCommandItem extends CommandItem {
  realShortcut?: Shortcut
  onlyOnHover?: boolean
}

/** Populate the display-only `shortcut` text (e.g. "⌘D") from each item's `realShortcut`. */
export const withDisplayShortcuts = (items: AppCommandItem[]): AppCommandItem[] =>
  items.map((item) =>
    item.realShortcut ? { ...item, shortcut: [getShortcutKeyString(item.realShortcut)] } : item,
  )

/** Feed the same shortcut objects powering the palette into the real keydown handler. */
export const toKeyboardShortcuts = (items: AppCommandItem[]): KeyboardShortCutItem[] =>
  items
    .filter((item): item is AppCommandItem & { realShortcut: Shortcut } =>
      Boolean(item.realShortcut),
    )
    .map((item) => ({
      shortcut: item.realShortcut,
      onlyOnHover: item.onlyOnHover,
      method: () => {
        item.action?.(item)
        return true
      },
    }))
